module.exports = __webpack_public_path__ + "img/not-found.aa3cbc8b.svg";